import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

import { NavigationProvider } from './context/NavigationContext';


import { Router, ReactLocation } from 'react-location';


import { AuthProvider } from './context/AuthContext';
// import { BerichtsheftProvider } from './context/BerichtsheftContext';

import RootPage from './components/RootPage';

import { positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from './components/alerts/AlertTemplate';
import { ModalsStateProvider } from './context/ModalsContext';


import axios from 'axios';

const location = new ReactLocation();

//const baseUrl = "https://berichtsheft-generator.app:443";
const baseUrl = process.env.NODE_ENV == 'production' ? "https://berichtsheft-generator.app:443": "http://alens-mac-mini.local:8181";

const LoginPage = React.lazy(() => import('./components/LoginPage'));
const RegisterPage = React.lazy(() => import('./components/RegisterPage'));
const DashboardPage = React.lazy(() => import('./components/DashboardPage'));
const DownloadEntries = React.lazy(() => import('./components/DownloadEntries'));
const ExportPage = React.lazy(() => import('./components/ExportPage'));
const RandomizeEntriesWizard = React.lazy(() => import('./components/RandomizeEntriesWizard'));
const CompleteEntryPage = React.lazy(() => import('./components/CompleteEntryPage'));
const SettingsPage = React.lazy(() => import('./components/SettingsPage'));
const PurchasePage = React.lazy(() => import('./components/PurchasePage'));
const ImportICalPage = React.lazy(() => import('./components/ImportICalPage'));
const ForgotPassword = React.lazy(() => import('./components/ForgotPassword'));
////console.log(localStorage.getItem('selectedFolderId'))

function handleSuccessfulAuthentication(response) {
  localStorage.setItem('accessToken', response.data.tokenPair.accessToken);
  localStorage.setItem('refreshToken', response.data.tokenPair.refreshToken);
  localStorage.setItem('user', JSON.stringify(response.data.user));
  if (localStorage.getItem('selectedYear') == null) {
    localStorage.setItem('selectedYear', `${response.data.user.startDate}`);
  }

}

function handleFailedAuthentication(error) {
  // console.error(error);
  // alert(error);
  localStorage.clear();
  window.location.href = "/login";

}



async function loader() {

  const client = axios.create({ baseURL: baseUrl });
  return {
    response: await client.post('/protected/validateAccessToken', {}, {
      headers: {
        'authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).catch(async (error) => await client.post('/protected/refreshAccessToken', {}, {
      headers: {
        'authorization': `Bearer ${localStorage.getItem('refreshToken')}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      ////console.log("refresh token returned...");
      handleSuccessfulAuthentication(response);
      return response;
    }).catch(async (error) => { handleFailedAuthentication(error); return error; })),
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>

    <AlertProvider template={AlertTemplate} timeout={8000} position={positions.BOTTOM_CENTER} offset={"4rem"}>
      <Router location={location} routes={[
        {
          path: '/',
          loader: loader,
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <RootPage />
            </Suspense>,
          errorElement: <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
            <LoginPage />
          </Suspense>,
        },
        {
          path: '/login', element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <LoginPage />
            </Suspense>,

        },
        {
          path: '/register',
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <RegisterPage />
            </Suspense>,
          loader: async () => ({
            jobs: await (await fetch(`${baseUrl}/jobs`)).json(),
            reportTypes: await (await fetch(`${baseUrl}/reportTypes`)).json(),
            incomingTemplates: await (await fetch(`${baseUrl}/templates`)).json(),
          }),
        },
        {
          path: '/purchase',
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <PurchasePage />
            </Suspense>,
          loader: async () => ({
            products: await (await fetch(`${baseUrl}/products`)).json(),

          }),
        },
        {
          path: '/download',
          loader: loader,
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <DownloadEntries />
            </Suspense>
          ,
        },
        {
          path: '/randomize',
          loader: loader,
          element: <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
            <RandomizeEntriesWizard />
          </Suspense>,
        },
        {
          path: '/export',
          loader: loader,
          element: <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
            <ExportPage />
          </Suspense>,
        },
        {
          path: '/forgot',
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <ForgotPassword />
            </Suspense>,
        },
        {
          path: '/dashboard',
          loader: async () => ({
            ...await loader(),
            jobs: await (await fetch(`${baseUrl}/jobs`)).json(),
            reportTypes: await (await fetch(`${baseUrl}/reportTypes`)).json(),
            incomingTemplates: await (await fetch(`${baseUrl}/templates`)).json(),
          }),
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <DashboardPage />
            </Suspense>,


        },
        {
          path: '/entryCompletion',
          loader: loader,
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <CompleteEntryPage />
            </Suspense>,
        },
        {
          path: '/importICal',
          loader: async () => ({
            ...await loader(),
            reportSections: await (await fetch(`${baseUrl}/protected/reportSections`, { method: "GET", headers: new Headers({ 'authorization': `Bearer ${localStorage.getItem('accessToken')}`, 'Accept': 'application/json', 'Content-Type': 'application/json' }) })).json(),
          }),
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <ImportICalPage />
            </Suspense>,
        },
        {
          path: '/settings',
          loader: async () => ({
            ...await loader(),
            incomingTemplates: await (await fetch(`${baseUrl}/templates`)).json(),
            reportSections: await (await fetch(`${baseUrl}/protected/reportSections`, { method: "GET", headers: new Headers({ 'authorization': `Bearer ${localStorage.getItem('accessToken')}`, 'Accept': 'application/json', 'Content-Type': 'application/json' }) })).json(),
            userTemplate: await (await fetch(`${baseUrl}/protected/getUserTemplate`, { method: "GET", headers: new Headers({ 'authorization': `Bearer ${localStorage.getItem('accessToken')}`, 'Accept': 'application/json', 'Content-Type': 'application/json' }) })).json(),
            reportSectionsMaxHours: await (await fetch(`${baseUrl}/protected/getMaxHours`, { method: "GET", headers: new Headers({ 'authorization': `Bearer ${localStorage.getItem('accessToken')}`, 'Accept': 'application/json', 'Content-Type': 'application/json' }) })).json(),
          }),
          element:
            <Suspense fallback={<div className={"flex w-full justify-center items-center h-32"}><button className="btn btn-square loading"></button></div>}>
              <SettingsPage />
            </Suspense>,
        }

      ]} >

        <NavigationProvider>
          <AuthProvider>
            <ModalsStateProvider>
              <App />
            </ModalsStateProvider>
          </AuthProvider>
        </NavigationProvider>

      </Router>
    </AlertProvider>

  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(////console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
